Namespace 'Customer.Filters.EditCustomAttributes'

class Customer.Filters.EditCustomAttributes.AppliedTagView extends Backbone.View
  tagName: 'span'
  className: 'label'
  template: JST['backbone/templates/customer/filters/tabs/edit_custom_attributes/applied_tag']
  events:
    'click .icon-remove': 'triggerRemoveEvent'

  initialize: ({name, code}) ->
    @name = name
    @code = code

  render: =>
    @$el.html(@template(name: @name))
    @

  triggerRemoveEvent: =>
    @trigger('remove', code: @code)
